<template>
  <section class="transaction-section">
    <NavigationBar />

    <!-- desktop -->
    <div
      v-if="!isVerySmall"
      class="uk-section uk-padding-remove-top uk-margin-top"
    >
      <div class="uk-container uk-margin-top">
        <div class="uk-flex" uk-grid>
          <NavigationProfile />
          <div class="uk-width-expand" v-if="!loading">
            <h3>History Transaction</h3>
            <hr />
            <div v-if="orders.length > 0">
              <div uk-grid v-for="(order, i) in orders" :key="i">
                <div class="uk-width-1-1">
                  <div
                    class="uk-card uk-card-body uk-card-default"
                    style="padding: 15px 0px"
                  >
                    <div uk-grid class="uk-margin-remove">
                      <div
                        class="uk-width-1-4 uk-flex uk-flex-start uk-flex-top"
                      >
                        <div>
                          <div class="uk-text-muted">No Transaction</div>
                          <div class="uk-text-bold">{{ order.no_tagihan }}</div>
                          <div class="uk-text-muted">{{ order.tgl }}</div>
                        </div>
                      </div>
                      <div
                        class="uk-width-1-4 uk-flex uk-flex-start uk-flex-top"
                        style="padding-left: 15px !important;"
                      >
                        <div>
                          <div class="uk-text-muted">Total</div>
                          <div class="uk-text-bold">
                            {{ priceRupiah(order.total_tagihan) }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="uk-width-1-3 uk-flex uk-flex-start uk-flex-top"
                        style="padding-left: 15px !important;"
                      >
                        <div>
                          <div class="uk-text-muted">Billing Status</div>
                          <div class="uk-text-bold">
                            <span
                              :class="`${
                                order.status_tagihan == 'Pending'
                                  ? 'pending-status'
                                  : order.status_tagihan == 'Paid'
                                  ? 'paid-status'
                                  : order.status_tagihan == 'Confirmed'
                                  ? 'confirmed-status'
                                  : 'cancel-status'
                              } status-transaction`"
                              >{{ order.status_tagihan }}</span
                            >
                          </div>
                          <div class="uk-text-muted" style="margin-top: 10px;" v-if="order.status_tagihan == 'Pending'">Payment Limit</div>
                          <div class="uk-text-bold" v-if="order.status_tagihan == 'Pending'">
                            <span class="status-transaction paid-status">{{ order.batas_waktu }}</span>
                          </div>
                        </div>
                      </div>
                      <div
                        class="uk-width-1-6 uk-flex uk-flex-start uk-flex-middle uk-padding-remove-left"
                        style="padding-left: 15px !important;"
                      >
                        <div class="uk-text-right">
                          <router-link
                            :to="`/profile/transaction/detail?id=${order.no_tagihan}`"
                            class="uk-button uk-button-primary uk-button-small"
                            style="font-size: 0.8vw !important"
                            >Detail</router-link
                          >
                        </div>
                      </div>
                    </div>
                    <hr style="margin: 15px 0px" />
                    <div
                      uk-grid
                      class="uk-margin-remove"
                      v-for="(invoice, j) in order.invoice"
                      :key="j"
                    >
                      <div class="uk-width-1-4 uk-flex uk-flex-start uk-flex-top">
                        <div style="width:100%;">
                          <div class="uk-text-muted">Products</div>
                          <div>
                            <ul style="padding-left: 0px; list-style: none">
                              <li
                                v-for="(product, k) in invoice.products"
                                :key="k"
                              >
                                <div class="uk-flex">
                                  <div class="uk-width-1-6">
                                    <img :src="$store.state.url + product.gambar" :alt="product.nama_product">
                                  </div>
                                  <div class="uk-width-expand uk-text-truncate">
                                    {{ product.nama_product }}
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="uk-width-1-4 uk-flex uk-flex-start uk-flex-top" style="padding-left: 15px !important;">
                        <div>
                          <div class="uk-text-muted">Merchant</div>
                          <div class="uk-text-bold">{{ invoice.penjual }}</div>
                        </div>
                      </div>
                      <div
                        class="uk-width-expand uk-flex uk-flex-start uk-flex-top"
                        style="padding-left: 15px !important;"
                      >
                        <div>
                          <div class="uk-text-muted">Purchase Status</div>
                          <div class="uk-text-bold">
                            {{ invoice.status_pembelian }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="uk-width-expand uk-flex uk-flex-center uk-flex-middle">
              <div>
                Transaction history does not exist
              </div>
            </div>
            <div
              class="uk-flex uk-flex-center uk-margin-top"
              v-if="totalPage > 1"
            >
              <div>
                <ul class="uk-pagination" uk-margin>
                  <li :class="page == 1 ? 'uk-disabled' : ''">
                    <a href="javascript:void(0);" @click="changePage(page - 1)"><span uk-pagination-previous></span></a>
                  </li>
                  <li v-for="i in totalPage" :key="i" :class="`${Number(page) == i ? 'uk-active uk-text-bold' : ''}`">
                    <a href="javascript:void(0);" @click="changePage(i)">{{ i }}</a>
                  </li>
                  <li :class="page == totalPage ? 'uk-disabled' : ''">
                    <a href="javascript:void(0);" @click="changePage(page + 1)"><span uk-pagination-next></span></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            class="uk-width-expand uk-flex uk-flex-center uk-flex-middle"
            v-else
          >
            <div class="">
              <div uk-spinner></div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- mobile -->
    <div v-else class="uk-section uk-padding-remove-top">
      <div class="uk-container uk-margin-top">
        <div class="uk-flex" uk-grid v-if="!loading">
          <div class="uk-width-1-1">
            <h3>History Transaction</h3>
          </div>
          <div v-if="orders.length > 0">
            <div uk-grid v-for="(order, i) in orders" :key="i">
              <div class="uk-width-expand">
                <div
                  class="uk-card uk-card-body uk-card-default"
                  style="padding: 15px 15px"
                >
                  <div uk-grid>
                    <div class="uk-width-1-1 uk-flex uk-flex-start">
                      <div>
                        <div class="uk-text-muted">No Transaction</div>
                        <div class="uk-text-bold">{{ order.no_tagihan }}</div>
                      </div>
                    </div>
                    <div
                      class="uk-width-1-1 uk-flex uk-flex-start uk-margin-small-top"
                    >
                      <div>
                        <div class="uk-text-muted">Total</div>
                        <div class="uk-text-bold">
                          {{ priceRupiah(order.total_tagihan) }}
                        </div>
                      </div>
                    </div>
                    <div class="uk-width-1-1 uk-flex uk-margin-small-top">
                      <div class="uk-width-1-2 uk-flex uk-flex-start">
                        <div>
                          <div class="uk-text-muted">Billing Status</div>
                          <span
                            :class="`${
                              order.status_tagihan == 'Pending'
                                ? 'pending-status'
                                : order.status_tagihan == 'Paid'
                                ? 'paid-status'
                                : order.status_tagihan == 'Confirmed'
                                ? 'confirmed-status'
                                : 'cancel-status'
                            } status-transaction`"
                            >{{ order.status_tagihan }}</span
                          >
                          <div class="uk-text-muted" style="margin-top:10px;" v-if="order.status_tagihan == 'Pending'">Payment Limit</div>
                          <span class="status-transaction paid-status" v-if="order.status_tagihan == 'Pending'">{{ order.batas_waktu }}</span>
                        </div>
                      </div>
                      <div
                        class="uk-width-1-2 uk-flex uk-flex-right uk-flex-bottom"
                      >
                        <div class="uk-text-right">
                          <router-link
                            class="uk-button uk-button-primary uk-button-small"
                            :to="`/profile/transaction/detail?id=${order.no_tagihan}`"
                            >Detail</router-link
                          >
                        </div>
                      </div>
                    </div>
                    <div class="uk-width-1-1">
                      <hr>
                    </div>
                    <div class="uk-width-1-1 uk-flex uk-margin-small-top" v-for="(invoice, j) in order.invoice" :key="j" uk-grid>
                      <div style="display: block;width: 100%;">
                        <div class="uk-text-muted">Products</div>
                        <div>
                          <ul style="padding-left: 0px; list-style: none">
                              <li
                                v-for="(product, k) in invoice.products"
                                :key="k"
                              >
                                <div class="uk-flex">
                                  <div class="uk-width-1-6">
                                    <img :src="$store.state.url + product.gambar" :alt="product.nama_product">
                                  </div>
                                  <div class="uk-width-expand uk-text-truncate">
                                    {{ product.nama_product }}
                                  </div>
                                </div>
                              </li>
                            </ul>
                        </div>
                      </div>
                      <div style="display: block;width: 100%;" class="uk-margin-remove-top">
                        <div class="uk-text-muted">Merchant</div>
                        <div class="uk-text-bold">
                          {{ invoice.penjual }}
                        </div>
                      </div>
                      <div style="display: block;width: 100%;" class="uk-margin-small-top">
                        <div class="uk-text-muted">Purchase Status</div>
                        <div class="uk-text-bold">
                          {{ invoice.status_pembelian }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else uk-grid>
            <div class="uk-width-1-1 uk-flex uk-flex-center uk-flex-middle">
              Transaction history does not exist
            </div>
          </div>
          <div
            class="uk-flex uk-width-1-1 uk-flex-center uk-margin-top" v-if="totalPage > 1"
          >
            <div>
              <ul class="uk-pagination" uk-margin>
                <li :class="page == 1 ? 'uk-disabled' : ''">
                  <a href="javascript:void(0);" @click="changePage(page - 1)"><span uk-pagination-previous></span></a>
                </li>
                <li v-for="i in totalPage" :key="i" :class="`${Number(page) == i ? 'uk-active uk-text-bold' : ''}`">
                  <a href="javascript:void(0);" @click="changePage(i)">{{ i }}</a>
                </li>
                <li>
                  <a href="javascript:void(0);" @click="changePage(page + 1)"><span uk-pagination-next></span></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          class="uk-width-expand uk-flex uk-flex-center uk-flex-middle"
          v-else
        >
          <div class="">
            <div uk-spinner></div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </section>
</template>

<script>
import NavigationBar from "@/components/NavigationBar.vue";
import Footer from "@/components/Footer.vue";
import NavigationProfile from "@/components/NavigationProfile.vue";
import { mapGetters, mapMutations } from "vuex";
import $axios from "../../api";

export default {
  components: {
    NavigationBar,
    Footer,
    NavigationProfile,
  },
  data() {
    return {
      orders: [],
      total: 0,
      page: 1,
      loading: true,
    };
  },
  mounted() {
    if (!this.IS_AUTH) {
      this.$router.push(`/?login=true&back=${window.location.origin + this.$route.path}`);
    } else {
      this.getData();
    }
  },
  computed: {
    ...mapGetters("auth", ["IS_AUTH", "GET_USER"]),
    isSmall() {
      return window.innerWidth < 960;
    },
    isVerySmall() {
      return window.innerWidth < 640;
    },
    totalPage() {
      return Math.ceil(this.total / 10);
    },
  },
  methods: {
    ...mapMutations("auth", ["SET_USER"]),
    priceRupiah: function (number) {
      let reverse = number.toString().split("").reverse().join("");
      let ribuan = reverse.match(/\d{1,3}/g);
      ribuan = ribuan.join(".").split("").reverse().join("");
      return "Rp " + ribuan;
    },
    getData() {
      $axios
        .post("customer/riwayat_pesanan", {
          id_cust: this.GET_USER.id,
          page: this.page,
        })
        .then((result) => {
          if (result.status == 200) {
            const data = result.data;
            if (data.success == 1) {
              this.orders = data.data_pembelian;
              this.total = data.total_pembelian;
              this.loading = false;
              window.scrollTo(0, 0)
            } else {
              // this.$router.push("/not-found");
              UIkit.notification({
                status: 'danger',
                message: 'Something went wrong!'
              })
            }
          } else {
            // this.$router.push("/not-found");
            UIkit.notification({
              status: 'danger',
              message: 'Something went wrong!'
            })
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$router.push("/not-found");
          UIkit.notification({
            status: 'danger',
            message: 'Something went wrong!'
          });
        });
    },
    changePage(page) {
      if (this.page != page) {
        this.page = page
        this.getData()
      }
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../custom/custom.less";
.transaction-section {
  font-size: 14px;
  .status-transaction {
    font-size: 11px;
    color: white;
    padding: 5px;
    border-radius: 4px;
  }
  .pending-status {
    background: @warning-color;
  }
  .paid-status {
    background: @success-color;
  }
  .confirmed-status {
    background: @info-color;
  }
  .cancel-status {
    background: @danger-color;
  }
}
</style>